export default {
  computed: {
    servCompName() {
      if (this.compProps.mate) {
        return this.compProps.mate.serviceComp
      } else {
        return ''
      }
    }
  },
  methods: {
    preventTouchMove(isShow) {
      if (isShow) {
        let cssStr = 'overflow-y: hidden; height: 100%'
        document.getElementsByTagName('html')[0].style.cssText = cssStr
        document.body.style.cssText = cssStr
      } else {
        let cssStr = 'overflow-y: auto; height: auto'
        document.getElementsByTagName('html')[0].style.cssText = cssStr
        document.body.style.cssText = cssStr
      }
    }
  }
}
